module.exports = __webpack_public_path__ + "static/media/setback.4e18ad22.svg";